import { createSlice } from '@reduxjs/toolkit'
import { createAxiosThunk } from 'utils/reduxUtil'
import {
  deleteRequestMember,
  postTrackMember,
  searchTrackAndTrackRight,
} from 'api/axios/crux/bcon'

const initialState = {
  visible: false,
  isLoading: false,
  showSearchResult: false,
  content: [],
  totalElements: 0,
  totalPages: 0,
  page: 0,
  searchType: 'NAME',
  searchKey: '',
  pagingSearchType: 'NAME',
  pagingSearchKey: '',
  isSubmitting: false,
  requestTracks: [],
}
export const fetchTrackAndTrackRight = createAxiosThunk(
  'requestTrack/fetchTrackAndTrackRight',
  ({ searchType, searchKey, page }) =>
    searchTrackAndTrackRight({ searchType, searchKey, page })
)
export const requestTrackMember = createAxiosThunk(
  'requestTrack/requestTrackMember',
  trackId => postTrackMember(trackId)
)
export const cancelTrackMember = createAxiosThunk(
  'requestTrack/cancelTrackMember',
  ({ trackId, requestId }) => deleteRequestMember({ requestId, trackId })
)
const requestTrackSlice = createSlice({
  name: 'requestTrack',
  initialState,

  reducers: {
    showRequestTrack: state => {
      state.visible = true
    },
    hideRequestTrack: () => initialState,
    setSearchType: (state, { payload }) => {
      state.searchType = payload
    },
    setSearchKey: (state, { payload }) => {
      state.searchKey = payload
    },
    clearForm: state => {
      state.searchKey = ''
      state.pagingSearchKey = ''
    },
    addRequestTrack: (state, { payload }) => {
      state.requestTracks.push(payload)
    },
  },

  extraReducers: builder => {
    builder.addCase(
      fetchTrackAndTrackRight.pending,
      (
        state,
        {
          meta: {
            arg: { page },
          },
        }
      ) => {
        state.page = page
        state.isLoading = true
        state.showSearchResult = true
      }
    )

    builder.addCase(
      fetchTrackAndTrackRight.fulfilled,
      (
        state,
        {
          payload: { body },
          meta: {
            arg: { page, searchKey, searchType },
          },
        }
      ) => {
        const { content, totalElements, totalPages } = body
        if (page > 0) {
          state.content = state.content.concat(content)
        } else {
          state.content = content
        }
        state.pagingSearchKey = searchKey
        state.pagingSearchType = searchType
        state.totalElements = totalElements
        state.totalPages = totalPages
        state.isLoading = false
      }
    )

    builder.addCase(fetchTrackAndTrackRight.rejected, state => {
      state.isLoading = false
    })

    builder.addCase(requestTrackMember.pending, state => {
      state.isSubmitting = true
    })

    builder.addCase(
      requestTrackMember.fulfilled,
      (state, { meta: { arg: trackId } }) => {
        const index = state.content.findIndex(item => item.trackId === trackId)
        if (index !== -1) {
          state.content[index].role = 'REQUEST'
        }
        state.isSubmitting = false
      }
    )

    builder.addCase(requestTrackMember.rejected, state => {
      state.isSubmitting = false
    })

    builder.addCase(cancelTrackMember.pending, state => {
      state.isSubmitting = true
    })

    builder.addCase(cancelTrackMember.fulfilled, state => {
      state.isSubmitting = false
    })

    builder.addCase(cancelTrackMember.rejected, state => {
      state.isSubmitting = false
    })
  },
})
export const {
  showRequestTrack,
  hideRequestTrack,
  setSearchType,
  setSearchKey,
  clearForm,
  addRequestTrack,
} = requestTrackSlice.actions
export default requestTrackSlice.reducer
